import {useTranslation} from 'react-i18next';
import {Select, Space} from 'antd';
import ReactCountryFlag from "react-country-flag";

const Localization = () => {
    const {i18n} = useTranslation();

    function changeLanguage(value) {
        i18n.changeLanguage(value);
        localStorage.setItem('i18nextLng', value);
    }

    return (
        <>
            <Space wrap>
                <Select
                    value={i18n.language}
                    defaultValue="uz"
                    style={{
                        width: 130,
                    }}
                    onChange={changeLanguage}
                    options={[
                        {
                            value: 'en',
                            label: (
                                <span className="localization-option">
                                    <ReactCountryFlag countryCode="GB" style={{fontSize: "1em"}}/>
                                    <span className="localization-option__text">English</span>
                                </span>
                            ),
                        },
                        {
                            value: 'ru',
                            label: (
                                <span className="localization-option">
                                    <ReactCountryFlag countryCode="RU" style={{fontSize: "1em"}}/>
                                    <span className="localization-option__text">Русский</span>
                                </span>
                            ),
                        },
                        {
                            value: 'uz',
                            label: (
                                <span className="localization-option">
                                    <ReactCountryFlag countryCode="UZ" style={{fontSize: "1em"}}/>
                                    <span className="localization-option__text">O‘zbekcha</span>
                                </span>
                            ),
                        },
                    ]}
                />
            </Space>
        </>
    );
};

export default Localization;
